//extracted by mini-css-extract-plugin
export default {"radioGroup":"commonStyle_radioGroup__MjLUH","fieldSet":"commonStyle_fieldSet__tXIcF","legend":"commonStyle_legend__52mN-"};;